import React, { useState, useRef } from 'react'
import { useMessaging } from './MessagingProvider'
import { useMutation } from '@tanstack/react-query'
import { apiPost } from '~/util/api'
import { Button } from '~/lib/ui/button'
import { Input } from '~/lib/ui/input'
import RichTextEditor from '~/lib/ui/rich-text-editor'
import useTranslation from '../shared/TranslationProvider'

const NewMessage = () => {
  const { t } = useTranslation('CoachMessageThread')
  const {
    queryClient,
    location,
    recipientCandidate,
    setRecipientCandidate,
    clearNewMessageMode,
    userIsCoach,
  } = useMessaging()
  const [newMessageSubject, setNewMessageSubject] = useState('')
  const editorRef = useRef(null)

  const postNewThread = async (request) => {
    const response = await apiPost(`${location.pathname}.json`, request)
    return response
  }

  const createThreadMutation = useMutation({
    mutationFn: postNewThread,
    onSuccess: (res) => {
      const {
        data: { coach_message_thread_id: newThreadId },
      } = res
      window.location.hash = newThreadId
      window.location.query = ''
      setRecipientCandidate(null)
      queryClient.invalidateQueries(['messageThreads'])
      setNewMessageSubject('')
      clearNewMessageMode()
      editorRef.current.setContents([])
      return true
    },
  })

  const cancel = () => {
    clearNewMessageMode()
    setRecipientCandidate(null)
    setNewMessageSubject('')
    editorRef.current.setContents([])
  }

  const createThread = () => {
    const newMessageBody = editorRef.current.getSemanticHTML()
    const candidateAttributes =
      userIsCoach && recipientCandidate
        ? { candidate_id: recipientCandidate.id }
        : {}
    const request = {
      coach_message_thread: {
        subject: newMessageSubject,
        body: newMessageBody,
        ...candidateAttributes,
      },
    }
    createThreadMutation.mutate(request)
  }
  const recipient = userIsCoach
    ? `${recipientCandidate?.first_name} ${recipientCandidate?.last_name}`
    : t('your_coach')

  if (userIsCoach && !recipientCandidate) return null

  return (
    <div className="flex flex-col gap-y-4">
      <h2>
        {t('message')} {recipient}
      </h2>
      <div>
        <label>{t('subject')}</label>
        <Input
          value={newMessageSubject}
          onChange={(e) => setNewMessageSubject(e.target.value)}
          placeholder={t('enter_subject')}
        />
      </div>
      <div>
        <label>{t('message')}</label>
        <RichTextEditor ref={editorRef} />
      </div>
      <div className="flex flex-row justify-start gap-x-2">
        <Button onClick={createThread} variant="coachcta">
          {t('send')}
        </Button>
        <Button onClick={cancel} variant="outline">
          {t('cancel')}
        </Button>
      </div>
    </div>
  )
}
export default NewMessage
